import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { HomeFaqs } from "src/sections/home/home-faqs";
import { HomeFeatures } from "src/sections/home/home-features";
import { HomeHero } from "src/sections/home/home-hero";
import { HomeReviews } from "src/sections/home/home-reviews";
import { HomeStats } from "src/sections/home/home-stats";
import { Box } from "@mui/material";
import { HomeHowItHelpsHowItWorks } from "src/sections/home/home-how-it-helps-how-it-works";
import { HomeScheduleCall } from "src/sections/home/home-schedule-call";
import { HomeFeatureShowcase } from "src/components/home/home-feature-showcase";
import { HomeTrustedClient } from "src/sections/home/home-trusted-client";
const Page = () => {
  usePageView();

  return (
    <>
      <Seo />
      <Box
        component="main"
        sx={{
          overflowX: "hidden",
          position: "relative",
          "& > section:not(.trusted-client-section)": {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minHeight: "100vh", // apply only to other sections
            py: { xs: 8, md: 12 },
            position: "relative",
          },
        }}
      >
        <HomeHero />
        <HomeFeatures />
        <HomeTrustedClient />
        <HomeFeatureShowcase />
        <HomeReviews />
        <HomeStats />
        <HomeHowItHelpsHowItWorks />
        <HomeScheduleCall />
        <HomeFaqs />
      </Box>
    </>
  );
};

export default Page;
